import axiosInstance from 'api/axiosInstance'
import {
    type AddCard,
    type AddCardInfoRequestDto,
    type AddDeposit,
    type AutoRecharge,
    type CardFeeResponse
} from 'types/api/payment'

export const postDeposit = async (deposit: AddDeposit) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/add-deposit',
        data: deposit
    })
    return data
}

export const postCard = async (card: AddCardInfoRequestDto) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: '/api/user/add-card',
        data: card
    })

    return data
}

export const editCard = async ({
    card,
    cardId
}: {
    card: AddCardInfoRequestDto
    cardId: string
}) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/update-card/${cardId}`,
        data: card
    })
    return data
}

export const getListCards = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/list-cards'
    })

    return data?.data
}

export const getSingleCard = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/single-card/${id}`
    })

    return data.data
}

export const deleteCard = async (id: string) => {
    const cardId = String(id ?? '').trim()

    if (!cardId) {
        throw new Error('Card public ID is required')
    }

    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/delete-card/${encodeURIComponent(cardId)}`
    })

    return data
}

export const putDefaultCard = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/set-active-card/${id}`
    })

    return data
}

export const putDefaultPaymetMethod = async (payload: {
    default_payment_method: 'wallet' | 'card'
}) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/payment-settings',
        data: payload
    })

    return data
}

export const putAutoRecharge = async (payload: AutoRecharge) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/auto-recharge',
        data: payload
    })

    return data
}
